import loadable from '@loadable/component';

export const EventShowAllRsvpsModalLoadable = loadable(
  () => import('./EventShowAllRsvpsModal'),
  { resolveComponent: (module) => module.EventShowAllRsvpsModal },
);
